var testimonialSliders = $('.testimonials__list');

if (testimonialSliders.length) {

    testimonialSliders.each(function() {
        var slider = $(this);

        slider.slick({
            centerMode: true,
            centerPadding: '0px',
            slidesToShow: 1,
            variableWidth: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 6000,
            accessibility: true,
            pauseOnHover: false
        });

    });
}
